export const BRAND_ORDER = [
  "Milnor",
  "Laco Machinery",
  "ADC",
  "Image",
  "Pony",
  "Forenta",
  "Supershine",
  "Itaclean",
  "LG",
];

export const TYPE_ORDER = [
  "Tunnel Washer",
  "Soft Mount",
  "Hard Mount",
  "Hygiene Barrier Washer",
  "Small Capacity",
  "Medium Capacity",
  "Large Capacity",
  "Roller Heated",
  "Chest Heated",
  "Folder",
  "Towel Folder",
  "Feeder",
  "Hot Head",
  "Hot Head Presses",
  "Drycleaning presses",
  "High Production Presses",
  "Form Finishers",
  "Conveyors",
  "Ironing Board",
  "Spotting board",
  "Steam Generator",
  "fabricated",
  "Multi solvent/Hydrocarbon",
];

const createOrderMap = (items) =>
  items.reduce((map, item, index) => {
    map[item.trim().toLowerCase()] = index;
    return map;
  }, {});

export const brandOrderMap = createOrderMap(BRAND_ORDER);
export const typeOrderMap = createOrderMap(TYPE_ORDER);

export const byConfiguredOrder = (orderMap) => (a, b) => {
  const aKey = a.trim().toLowerCase();
  const bKey = b.trim().toLowerCase();
  const aIndex = orderMap[aKey] ?? Number.MAX_SAFE_INTEGER;
  const bIndex = orderMap[bKey] ?? Number.MAX_SAFE_INTEGER;

  if (aIndex !== bIndex) {
    return aIndex - bIndex;
  }

  return a.localeCompare(b, undefined, { sensitivity: "base" });
};

export const byProductTitle = (a, b) =>
  (a.title || "").localeCompare(b.title || "", undefined, {
    numeric: true,
    sensitivity: "base",
  });
